"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var table_row_type_1 = require("../../model/table-row-type");
var TableViewManager = /** @class */ (function () {
    function TableViewManager() {
    }
    /**
     * Fill table's rows options.
     * @param {Array<Row>} body Table body.
     * @param {TableOptions} options    Table row's options to be filled.
     */
    TableViewManager.fillTableBodyOptions = function (body, options) {
        var rowsCount = body.length;
        for (var i = 0; i < rowsCount; i++) {
            var rowOption = options.get(i);
            if (rowOption !== undefined) {
                var animate = rowOption.animate;
                var type = rowOption.type;
                var row = body[i];
                switch (type) {
                    case table_row_type_1.TableRowType.NEW: {
                        row.animate = animate;
                        row.isNew = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.BEFORE_NEW: {
                        row.animate = animate;
                        row.isBeforeNew = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.AFTER_NEW: {
                        row.animate = animate;
                        row.isAfterNew = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.CREATED: {
                        row.animate = animate;
                        row.isCreated = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.BEFORE_CREATED: {
                        row.animate = animate;
                        row.isBeforeCreated = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.AFTER_CREATED: {
                        row.animate = animate;
                        row.isAfterCreated = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.HIGHLIGHTED: {
                        row.animate = animate;
                        row.isHighlighted = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.COLLAPSED: {
                        row.animate = animate;
                        row.isCollapsed = true;
                        row.isExpanded = false;
                        break;
                    }
                    case table_row_type_1.TableRowType.EXPANDED: {
                        row.animate = animate;
                        row.isCollapsed = false;
                        row.isExpanded = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.REMOVED: {
                        row.animate = animate;
                        row.isRemoved = true;
                        break;
                    }
                }
            }
        }
    };
    TableViewManager.fillTableBodyHighlightedOptions = function (body, options) {
        var rowsCount = body.length;
        for (var i = 0; i < rowsCount; i++) {
            var rowOption = options.get(i);
            var row = body[i];
            row.isHighlighted = false;
            row.isGoingToRemoved = false;
            if (rowOption !== undefined) {
                var type = rowOption.type;
                switch (type) {
                    case table_row_type_1.TableRowType.HIGHLIGHTED: {
                        row.isHighlighted = true;
                        break;
                    }
                    case table_row_type_1.TableRowType.HIGHLIGHT_REMOVE: {
                        row.isGoingToRemoved = true;
                        break;
                    }
                }
            }
        }
    };
    return TableViewManager;
}());
exports.TableViewManager = TableViewManager;
//# sourceMappingURL=table-view-manager.js.map